import { merge } from 'lodash'

type Merge = typeof merge

export const objectMerge: Merge = merge
